"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Portal = void 0;
var Portal_1 = __importDefault(require("./Portal"));
exports.Portal = Portal_1.default;
exports.default = { Portal: Portal_1.default };
//# sourceMappingURL=index.js.map